import {decorate, observable, action, computed} from 'mobx';

class Store {
    results = []
    manuallyChangedRows = []
    isRootCheckboxChecked = false

    setResults = value => {
        this.results = value
    }

    setManuallyChangedRows(selected, rootIsSelected) {
        this.isRootCheckboxChecked = rootIsSelected
        this.manuallyChangedRows = selected
    }
}

decorate(Store, {
    manuallyChangedRows: observable,
    results: observable,
    isRootCheckboxChecked: observable
})

const store = new Store();
export default store;